import { _ } from "libs";
import React from "react";
import { Route } from "react-router-dom";
import SettingsSidebar from "../components/settingsSidebar";
import Profile from "./settings/profile";
import Billing from "./settings/billing";
import Account from "./settings/account";
import Notifications from "./settings/notifications";
import Memberships from "./settings/memberships";
import Privacy from "./settings/privacy";

const Settings = () => {
	return (
		<div className="settingsPage">
			<div className="wrap">
				<div className="contentWrapper">
					<div className="contentLeft">
						<div className="fixedSidebar">
							<h1>{_("settings.heading")}</h1>
							<SettingsSidebar />
						</div>
					</div>
					<div className="contentRight">
						<Route exact path="/settings/account" component={Account} />
						<Route exact path="/settings/profile" component={Profile} />
						<Route exact path="/settings/billing" component={Billing} />
						<Route exact path="/settings/memberships" component={Memberships} />
						<Route exact path="/settings/notifications" component={Notifications} />
						<Route exact path="/settings/privacy" component={Privacy} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Settings;
